module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addcase"
  }, [_c('mt-header', {
    attrs: {
      "title": _vm.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goback($event)
      }
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "infobody"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.workList.length > 0),
      expression: "workList.length>0"
    }],
    staticClass: "casebox"
  }, _vm._l((_vm.workList), function(item) {
    return _c('div', {
      key: item.workId,
      staticClass: "case"
    }, [_c('div', {
      staticStyle: {
        "width": "90%"
      }
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.industryName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "text-align": "right"
      },
      on: {
        "click": function($event) {
          _vm.$router.push('/editcase?item=' + JSON.stringify(item))
        }
      }
    }, [_c('van-icon', {
      attrs: {
        "name": "arrow"
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "add",
    on: {
      "click": function($event) {
        return _vm.$router.push('/editcase')
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "plus"
    }
  }), _vm._v(" "), _c('p', [_vm._v("添加案例")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlebox",
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('h1', [_vm._v("案例")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f5c2a96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/my/addcase.vue
// module id = 1291
// module chunks = 1